import FormControl from "../base/FormControl";

export default class InputFile extends FormControl {

    constructor(props) {
        super(props);
        this.state.type = "file";
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    render() {
        return super.render();
    }
}